import { FC, useState } from 'react';

import { Drawer, Stack, TextField } from '@mui/material';

import { PrimaryButton, SecondaryButton } from '@/components/Shared/Buttons';

import { UserAccess } from '../types';

type EditUserSidepanelProps = {
  user: UserAccess;
  isSubmitting: boolean;
  onCancel: () => void;
  onSubmit: (firstName: string, lastName: string) => void;
};

const textFieldSx = {
  'input, label, fieldset': { fontSize: 14 },
  input: { padding: '13px 14px' },
  label: { marginTop: '-3px' },
};

export const EditUserSidepanel: FC<EditUserSidepanelProps> = ({ user, isSubmitting, onCancel, onSubmit }) => {
  const [firstName, setFirstName] = useState(user.firstName ?? '');
  const [lastName, setLastName] = useState(user.lastName ?? '');

  return (
    <Drawer open anchor="right">
      <div
        style={{
          display: 'flex',
          height: '100%',
          width: 400,
          flexDirection: 'column',
          justifyContent: 'space-between',
          padding: 20,
          background: '#2c2c2c',
        }}>
        <Stack flex="auto 1 1" spacing="20px">
          <p style={{ fontWeight: '600', margin: '8px 0 12px' }}>Edit user</p>
          <TextField label="Email" value={user.email} disabled sx={textFieldSx} />
          <TextField
            label="First name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            autoFocus
            sx={textFieldSx}
          />
          <TextField
            label="Last name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            sx={textFieldSx}
          />
        </Stack>
        <div style={{ height: 40, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <SecondaryButton width={150} label="Cancel" onClick={onCancel} />
          <PrimaryButton
            width={150}
            label="Update"
            disabled={isSubmitting}
            onClick={() => onSubmit(firstName.trim(), lastName.trim())}
          />
        </div>
      </div>
    </Drawer>
  );
};
